import pic1 from '../assets/img/gallery/1.jpg'
import pic2 from '../assets/img/gallery/2.jpg'
import pic3 from '../assets/img/gallery/3.jpg'
import pic4 from '../assets/img/gallery/4.jpg'
import pic01 from '../assets/img/gallery/01.jpg'
import pic02 from '../assets/img/gallery/02.jpg'
import pic03 from '../assets/img/gallery/03.jpg'
import pic04 from '../assets/img/gallery/04.jpg'
import pic05 from '../assets/img/gallery/05.jpg'
import pic06 from '../assets/img/gallery/06.jpg'
import pic07 from '../assets/img/gallery/07.jpg'

import { useEffect, useRef, useState, useCallback } from 'react'
import { MdOutlineNavigateNext } from 'react-icons/md'
import { useInView } from 'react-intersection-observer'
import { getGalleryItems, urlFor } from '../services/sanity.service'

const fallbackStaticItems = [
    {
        title: 'באמצע תהליך בניית קיר גבס',
        description: 'בניית קיר גבס חוץ עם בידוד 24 קילו למטר להפחתת רעש',
        image: pic2,
    },
    {
        title: 'ככה זה נשאר כשהלכנו',
        description: 'הקיר השפכטל והצבע לפני הגעת החלונות והדלת',
        image: pic1,
    },
    {
        title: 'החלפת מטבח, צנרת ופתיחת החלל',
        description: 'בסיום העבודה רגע לפני השיש וחיפוי הקרמיקה הכל צבוע מורכב ומכן',
        image: pic3,
    },
    {
        title: 'שבירת קירות ופינוי עפ"י אישור קונסטרוקטור',
        description: 'שבירת קירות ופינוי לפי חוק',
        image: pic4,
    },
]

const fallbackCarouselImages = [pic01, pic02, pic03, pic04, pic05, pic06, pic07]

export function Gallery() {
    const { ref: gallery, inView: isVisible } = useInView()
    const { ref: carouselScroll, inView: CaruselsVisible } = useInView()
    const carousel = useRef()
    
    const [activeIndex, setActiveIndex] = useState(0)
    const [isHovered, setIsHovered] = useState(false)
    const [staticItems, setStaticItems] = useState(fallbackStaticItems)
    const [carouselImages, setCarouselImages] = useState(fallbackCarouselImages)

    const scrollToIndex = useCallback((index) => {
        if (!carousel.current) return
        const slideWidth = carousel.current.offsetWidth
        carousel.current.scrollTo({
            left: -index * slideWidth,
            behavior: 'smooth'
        })
    }, [])

    const onNext = useCallback(() => {
        if (!carousel.current) return
        const slideWidth = carousel.current.offsetWidth
        if (slideWidth === 0) return
        const scrollLeft = Math.abs(carousel.current.scrollLeft)
        const currentIdx = Math.round(scrollLeft / slideWidth)
        const nextIndex = (currentIdx + 1) % carouselImages.length
        scrollToIndex(nextIndex)
    }, [carouselImages.length, scrollToIndex])

    const onPrev = useCallback(() => {
        if (!carousel.current) return
        const slideWidth = carousel.current.offsetWidth
        if (slideWidth === 0) return
        const scrollLeft = Math.abs(carousel.current.scrollLeft)
        const currentIdx = Math.round(scrollLeft / slideWidth)
        const prevIndex = (currentIdx - 1 + carouselImages.length) % carouselImages.length
        scrollToIndex(prevIndex)
    }, [carouselImages.length, scrollToIndex])

    useEffect(() => {
        async function loadGallery() {
            const items = await getGalleryItems()
            if (items && items.length > 0) {
                const sanityStatic = items
                    .filter(item => item.type === 'static')
                    .map(item => ({
                        title: item.title,
                        description: item.description,
                        image: urlFor(item.image).url(),
                    }))
                const sanityCarousel = items
                    .filter(item => item.type === 'carousel')
                    .map(item => urlFor(item.image).url())

                if (sanityStatic.length > 0) setStaticItems(sanityStatic)
                if (sanityCarousel.length > 0) setCarouselImages(sanityCarousel)
            }
        }
        loadGallery()
    }, [])

    useEffect(() => {
        // Only autoplay when the carousel is actually visible on screen
        if (isHovered || !CaruselsVisible) return

        const interval = setInterval(() => {
            onNext()
        }, 4000) // Auto-scroll every 4 seconds

        return () => clearInterval(interval)
    }, [isHovered, CaruselsVisible, onNext])

    useEffect(() => {
        const handleResize = () => {
            if (carousel.current) {
                const slideWidth = carousel.current.offsetWidth
                carousel.current.style.scrollBehavior = 'auto'
                carousel.current.scrollTo({
                    left: -activeIndex * slideWidth,
                })
                carousel.current.style.scrollBehavior = 'smooth'
            }
        }
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [activeIndex])

    const handleScroll = () => {
        if (!carousel.current) return
        const scrollLeft = Math.abs(carousel.current.scrollLeft)
        const slideWidth = carousel.current.offsetWidth
        if (slideWidth > 0) {
            const newIndex = Math.round(scrollLeft / slideWidth)
            if (newIndex !== activeIndex && newIndex >= 0 && newIndex < carouselImages.length) {
                setActiveIndex(newIndex)
            }
        }
    }

    return <>
        <div className={`gallery main-layout full ${isVisible ? 'visible' : ''}`} id='gallery' ref={gallery}>
            <header>
                <h2>קצת ממה שעשינו:</h2>
            </header>
            <section className="about-us">
                {staticItems.map((item, index) => (
                    <div key={index}>
                        <h3 className='primary-400'>{item.title}</h3>
                        <p className='secondary-200'>{item.description}</p>
                        <div className='img' style={{
                            backgroundImage: `url(${item.image})`
                        }} />
                    </div>
                ))}
            </section >
        </div >
        <div className={`gallery-carusle ${CaruselsVisible ? 'visible' : ''}`} ref={carouselScroll} >
            <div className="carousel-wrapper">
                <button
                    aria-label='previous'
                    className='prev'
                    onClick={onNext}
                >
                    <MdOutlineNavigateNext />
                </button>
                <div 
                    className='carousel' 
                    ref={carousel}
                    onScroll={handleScroll}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    {carouselImages.map((imgSrc, index) => (
                        <img key={index} src={imgSrc} alt="" />
                    ))}
                </div>
                <button
                    aria-label='next'
                    className='next'
                    onClick={onPrev}
                >
                    <MdOutlineNavigateNext />
                </button>
            </div>

            <div className="carousel-indicators">
                {carouselImages.map((_, index) => (
                    <button
                        key={index}
                        className={`indicator-dot ${index === activeIndex ? 'active' : ''}`}
                        onClick={() => scrollToIndex(index)}
                        aria-label={`Go to slide ${index + 1}`}
                    />
                ))}
            </div>
        </div>
    </>
}